import { Select, TextField, styled } from "@mui/material";

export const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    fontSize: '20px',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#B2BAC2',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#A5D9EE',
    },
    '&:hover fieldset': {
      borderColor: '#A5D9EE',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#A5D9EE',
      fontSize: '20px',
    },
    'margin': '10px'
  },
});
